import _ from 'ckLodash';
import utils from 'utils/utils';

function hasPixelLetterSpacing(letterSpacingNode) {
    var letterSpacingValue = letterSpacingNode.getStyle('letter-spacing');
    return /px/.test(letterSpacingValue);
}

function getAllPixelLetterSpacingSpans(editable) {
    var result = [];
    var letterSpacingNodes = editable.find('span[style*="letter-spacing:"]');
    var index;
    var count = letterSpacingNodes.count();
    for (index = 0; index < count; index++) {
        var letterSpacingNode = letterSpacingNodes.getItem(index);
        if (hasPixelLetterSpacing(letterSpacingNode)) {
            result.push(letterSpacingNode);
        }
    }

    return result;
}

function convertFromPixelsToEM(letterSpacingNode, parentBlock) {
    var letterSpacingValue = letterSpacingNode.getStyle('letter-spacing');
    var baseSize = getComputedStyle(parentBlock.$)['font-size'];
    return parseFloat(letterSpacingValue) / parseFloat(baseSize);
}

function convertPixelLetterSpacingToEM(letterSpacingNode) {
    var elementPath = new CKEDITOR.dom.elementPath(letterSpacingNode);
    var parentBlock = utils.getBlockParent(elementPath);

    var emSize = convertFromPixelsToEM(letterSpacingNode, parentBlock);

    letterSpacingNode.setStyle('letter-spacing', emSize + 'em');
}

function handleInput(editable) {
    var pixelLetterSpacingNodes = getAllPixelLetterSpacingSpans(editable);
    _.forEach(pixelLetterSpacingNodes, convertPixelLetterSpacingToEM);

    if (!editable.editor.WIX.isKeyDown) {
        editable.editor.fire('change');
    }
}

function init(editor) {
    editor.on('contentDom', function () {
        var editable = editor.editable();
        editable.on('input', _.partial(handleInput, editable));
    });
}

export default {
    init: init
};
